import { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import SubscribeViaEmailForm from './SubscribeViaEmailForm'

const SubscribeViaEmailModal = () => {
  const [showSubscribeModal, setShowSubscribeModal] = useState(false)

  useEffect(() => {
    const alreadySubscribed = window.localStorage.getItem('subscribeToBlog:success')
    const declinedSubscription = window.localStorage.getItem('subscribeToBlog:decline')

    if (alreadySubscribed) {
      return
    }

    // if user skipped the modal - not showing it for another 1 day
    if (declinedSubscription) {
      const now = +new Date()
      if (now - declinedSubscription < 1000 * 60 * 60 * 24) {
        return
      }
    }

    // show modal after 15 seconds
    setTimeout(() => {
      setShowSubscribeModal(true)
    }, 15 * 1000)
  }, [])

  function handleModalClose () {
    window.localStorage.setItem('subscribeToBlog:decline', (+new Date()).toString())
    setShowSubscribeModal(false)
  }

  function handleOnSubscribe () {
    setTimeout(() => {
      setShowSubscribeModal(false)
    }, 1500)
  }

  return (
    <Modal
      size='lg'
      centered
      show={showSubscribeModal}
      onHide={handleModalClose}
    >
      <SubscribeViaEmailForm
        onSubscribe={handleOnSubscribe}
      />
    </Modal>
  )
}

export default SubscribeViaEmailModal
